var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { DexfSettingsUtility, LocalizedInformationAlternateLanguage } from '@inter-ikea-kompis/utilities';
import { Choice as SkapaChoice, ChoiceItem as SkapaChoiceItem } from '@ingka/choice-webc/passive.js';
/**
 * LanguageSelectorCard class.
 *
 * @event change Triggered when a new language is selected
 */
export default class LanguageSelectorCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "settings" instead.
        this.localizedInformation = null;
        // The settings retrieved from settings service.
        this.settings = null;
        this.dexfSettings = null;
    }
    async connectedCallback() {
        this.customElements.define('skapa-choice', SkapaChoice);
        this.customElements.define('skapa-choice-item', SkapaChoiceItem);
        super.connectedCallback();
    }
    render() {
        // We want settings to be required, but since both props to provide settings are optional, this check is needed until localizedInformation is removed.
        if (!this.hasSettings()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				skapa-choice-item:last-child {
					margin-bottom: 0;
				}
			</style>
			<skapa-choice subtle> ${this.getChoiceItems()} </skapa-choice>
		`;
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has('localizedInformation') &&
            this.localizedInformation &&
            !this.settings) {
            this.dexfSettings = DexfSettingsUtility.parseLocalizedInformation(this.localizedInformation);
        }
        if (changedProperties.has('settings') && this.settings) {
            this.dexfSettings = this.settings;
        }
        return true;
    }
    hasSettings() {
        return !!this.dexfSettings || !!this.localizedInformation;
    }
    getSettings() {
        return this.dexfSettings;
    }
    /**
     * Gets choice items.
     *
     * @returns Template.
     */
    getChoiceItems() {
        return LocalizedInformationAlternateLanguage.getAlternateLanguages(this.getSettings(), this.locale).map((language) => html `
				<skapa-choice-item
					@click="${() => {
            this.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { locale: language.locale } }));
        }}"
					.selected="${this.locale === language.locale}"
				>
					<span slot="title">${language.label}</span>
				</skapa-choice-item>
			`);
    }
}
__decorate([
    property({ type: Object })
], LanguageSelectorCard.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], LanguageSelectorCard.prototype, "settings", void 0);
__decorate([
    property({ type: Object })
], LanguageSelectorCard.prototype, "theme", void 0);
__decorate([
    property({ type: String, required: true })
], LanguageSelectorCard.prototype, "locale", void 0);
//# sourceMappingURL=LanguageSelectorCard.js.map